import * as React from "react"
import { useEffect } from "react"
import {array, object, string, ref} from "yup";
import {useValidatorSeeker} from "@ui-seeker/app";
import { Box } from "@mui/material"

import { CommonFilters } from "@components"
import {COMMON_FILTER_KEYS, PRICING_ROUTES, WEBBACK_V2_API} from "@constants"
import { useAppDefaultFilters } from "@hooks"
import {disabledCommonFiltersSubmit, isLoadingCommonFilters, isSystemBusy, retailer, secondRetailer} from "@signals"
import { sideComparisonIsEmpty } from "./@signals"



export default function PricingSideComparisonFilters() {
    const { callUserDefaultFilters, userFilters, isLoadingDefaultFilters } = useAppDefaultFilters(PRICING_ROUTES.SIDE_COMPARISON_ID, PRICING_ROUTES.ACCESS_KEY)

    useEffect(() => {
        callUserDefaultFilters()
    }, [])

    const { isValid, errors } = useValidatorSeeker({
            retailer: retailer.value,
            secondaryRetailer: secondRetailer.value
        }, object({
            retailer: Array.isArray(retailer.value)
                ? array()
                    .min(1, 'Retailer is required')
                    .max(1, 'Only one retailer can be selected')
                    .test('not-same', 'Retailers must be different', function (val) {
                        const secondary = this.resolve(ref('secondaryRetailer'));
                        return !val?.includes(secondary);
                    })
                : string().required('Retailer is required')
                .notOneOf([ref('secondaryRetailer')], 'Retailers must be different'),

            secondaryRetailer: string().required('Second Retailer is required')
                .test('not-same', 'Retailers must be different', function (val) {
                    const primary = this.resolve(ref('retailer'));
                    if (Array.isArray(primary)) {
                        return !primary.includes(val);
                    }
                    return val !== primary;
                }),
        })
    )

    useEffect(() => {
        disabledCommonFiltersSubmit.value = !isValid
    }, [isValid])

    const normalizedUserFilters = userFilters
        ? {
            ...userFilters,
            ...(Array.isArray(userFilters.retailer) && { retailer: parseInt(userFilters.retailer[0]) }),
            ...(Array.isArray(userFilters.secondRetailer) && { secondRetailer: parseInt(userFilters.secondRetailer[0]) }),
        }
        : userFilters

    return <Box data-tour="side-comparison-filters">
    <CommonFilters
        components={{
            country: true, sitesCompare: true,
            category: true, brand: true,
            sku: true, favFilters: true,
            skuGroup: true, productsInStock: true,
            withShippingPrice: true
        }}
        downloadCSV={`${WEBBACK_V2_API}/pricing/side-comparison/csv`}
        compProps={{
            favFilters: {
                grid: { md: 3 },
                allowedFilters: [
                    COMMON_FILTER_KEYS.COUNTRY, COMMON_FILTER_KEYS.RETAILER, COMMON_FILTER_KEYS.CATEGORY, COMMON_FILTER_KEYS.BRAND,
                    COMMON_FILTER_KEYS.SKU_GROUP, COMMON_FILTER_KEYS.SKU, COMMON_FILTER_KEYS.INCLUDE_SHIPPING_PRICE,
                    COMMON_FILTER_KEYS.PRODUCTS_IN_STOCK
                ],
                dashboardKey: PRICING_ROUTES.SIDE_COMPARISON_ID
            },
            productsInStock: { grid: { md: 2, xs: 2 } },
            withShippingPrice: { grid: { md: 6, xs: 6 }},
            country: { grid: { md: 4, xs: 4 } },
            category: { grid: { md: 4, xs: 4 } },
            brand: { grid: { md: 4, xs: 4 } },
            skuGroup: { grid: { xs: 12, md: 6 } },
            sku: { grid: { xs: 12, md: 6 }, limitTags: 2 },
            sitesCompare: {
                grid: { xs: 12, md: 12 },
                retailer1Grid: { xs: 5 },
                vsGrid: { xs: 2 },
                retailer2Grid: { xs: 5 },
                retailerSignal: retailer,
                retailerErrors: errors?.retailer,
                retailerSecondarySignal: secondRetailer,
                secondaryRetailerErrors: errors?.secondaryRetailer
            },
        }}
        onSubmit={() => {
            sideComparisonIsEmpty.value = false
            isLoadingCommonFilters.value = true
            isSystemBusy.value = false
        }}
        defaultValues={normalizedUserFilters}
        isLoadingDefaultFilters={isLoadingDefaultFilters}
    />
    </Box>
}